/** Parse Azure Blob SAS `sp` (signed permissions) from a pre-signed URL. */
export function getAzureSasPermissions(preSignedURL: string): string | null {
	try {
		return new URL(preSignedURL).searchParams.get('sp');
	} catch {
		return null;
	}
}

/**
 * Put Block + Put Block List need write/create/add on the blob.
 * `sp=r` is read-only and always returns 403 AuthorizationPermissionMismatch.
 */
export function azureSasAllowsBlobUpload(sp: string | null): boolean {
	if (!sp) {
		return true;
	}
	return /[wac]/i.test(sp);
}

export function describeAzureSasPermissions(sp: string | null): string {
	return sp ?? '(missing sp parameter)';
}
